import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/app/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
        <BrandMark size="lg" to="/" testid="login-brand" className="mb-6 gap-3" withTagline />
        <h1 className="text-2xl font-bold tracking-tight">Sign in</h1>
        <p className="text-sm text-slate-500 mt-1">Manage your truck. Go live in seconds.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="focus:ring-[#E8650A] focus:border-[#E8650A]"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="focus:ring-[#E8650A] focus:border-[#E8650A]"
              data-testid="login-password-input"
            />
          </div>
          <Button type="submit" disabled={loading} className="ff-btn-primary w-full" data-testid="login-submit-button">
            {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Sign in
          </Button>
        </form>

        <div className="text-sm text-slate-500 mt-6 text-center">
          New here?{" "}
          <Link to="/register" className="text-[#E8650A] font-semibold" data-testid="link-to-register">
            Create your vendor account
          </Link>
        </div>
      </div>
    </div>
  );
}
